import constate from 'constate';
import type { FunctionComponent, PropsWithChildren, RefObject } from 'react';
import type { UseNavigate } from '../../types/dependencies';

export type TourEditorPageProps = {
  useNavigate: UseNavigate;
  mimesisStepEngineUrl: string;
  fileServiceDynamicLink: string;
  isDebugMode: boolean;
  deeplinkProtocol: string;
  uuid: string;
  tabId?: number;
  activeTabId?: number;
  rootElement?: RefObject<HTMLDivElement>;
  isDiscardModalOpen?: boolean;
  onUpdateEditorTabVisibility?: (show: boolean) => void;
  setIsDiscardModalOpen?: (val: boolean) => void;
  onIsTourModifiedChange?: (val: boolean) => void;
  onExit?: () => void;
};

export const [TourEditorPageProvider, useTourEditorPageProps]: [
  FunctionComponent<PropsWithChildren<TourEditorPageProps>>,
  () => TourEditorPageProps,
] = constate(
  (
    props: Omit<
      TourEditorPageProps,
      'isDiscardModalOpen' | 'setIsDiscardModalOpen'
    >
  ) => props
);
